import React from 'react';

const KeyValueDisplay = (props) => {
    const capitalize = (word) => word.slice(0, 1).toUpperCase() + word.slice(1);

    const kvps = Object.entries(props.data)
        .map(arr => ({ key: arr[0], value: arr[1] }))
        .filter(d => !props.whitelist || props.whitelist.includes(d.key))
        .map(d => (
            <div key={d.key} className="col-6 my-1 text-sm d-flex align-items-center" style={{ minHeight: "1.75rem" }}><strong className="mr-2">{capitalize(d.key)}:</strong>{d.value}</div>
        ));

    return (
        <div className="d-flex flex-row flex-wrap">
            {
                kvps.length > 0 ? kvps : <p>"No data to display"</p>
            }
        </div>
    );
}

export default KeyValueDisplay;